/**
 * Utilidades de usuario
 */

import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { setLang } from "../../redux/reducers";
import { getFullUsuarios } from "../ConnectDataBase";
import { SCREEN_IDS } from "../../components/FullComponent.js";
import { EquiposFabricacion } from "../../constants/Constants.js";

/**
 * Obtiene el idioma actual del usuario
 * @returns {string} Código del idioma
 */
export function getLanguage() {
  const dispatch = useDispatch();
  const langCookie = Cookies.get("lang");

  if (langCookie) {
    return langCookie; //langCookie;
  } else {
    const langCookie = navigator.language || navigator.userLanguage;
    dispatch(setLang(langCookie));
    return langCookie === "es" ? langCookie : "en";
  }
}

/**
 * Obtiene usuarios completos agrupados por equipo
 * @returns {Promise<Object>} Usuarios agrupados por equipo
 */
export async function getFullUser() {
  const listaOperarios = await getFullUsuarios(
    SCREEN_IDS.INFO_DIARIO,
    "Query",
    "userQuery"
  );

  const agrupadosPorEquipo = listaOperarios
    .filter((operario) => EquiposFabricacion.includes(operario.team))
    .reduce((acc, operario) => {
      // Inicializar el array para el equipo si aún no existe
      if (!acc[operario.team]) {
        acc[operario.team] = [];
      }
      // Agregar el operario al array de su equipo
      acc[operario.team].push(operario);
      return acc;
    }, {});
}

/**
 * Elimina un usuario
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {Object} usuarioSelected - Usuario seleccionado
 * @returns {Promise<string|undefined>} "ok" si se eliminó correctamente
 */
export async function deleteUser(currentScreenId, usuarioSelected) {
  try {
    const teamKey = Object.keys(DEPARTAMENTS).find(
      (key) => DEPARTAMENTS[key] === usuarioSelected.team
    );

    if (teamKey !== null) {
      usuarioSelected.team = teamKey;
    } else {
      console.error(
        "No se encontró la clave para el equipo:",
        usuarioSelected.team
      );
    }

    const dataOk = await deleteNewUser(
      currentScreenId,
      typeConnect[2],
      usuarioSelected
    );
    if (dataOk) {
      return "ok";
    }
  } catch (error) {
    console.error(error);
  }
}
